/* eslint-disable */
import { call, CreateTransactionBody } from 'services/api-service'

/**
 * Post a transaction (js feed)
 *
 * @method
 * @name ApiService#createTransaction
 * @param {CreateTransactionBody} body -
 */
function createTransaction(body: CreateTransactionBody): Promise<void> {
  return call<void>('POST', '/{siteKey}/transaction/{locale}', {}, [], [], [], body)
}

export default { createTransaction }
